import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableDefaultVariants = {}
const tableCompoundVariants = []

const tableSlotNames = [
  [
    "wrapper",
    "table__wrapper"
  ],
  [
    "table",
    "table__table"
  ],
  [
    "overlay",
    "table__overlay"
  ],
  [
    "placeholder",
    "table__placeholder"
  ],
  [
    "empty",
    "table__empty"
  ],
  [
    "scrollLoading",
    "table__scrollLoading"
  ],
  [
    "scrollFallback",
    "table__scrollFallback"
  ]
]
const tableSlotFns = /* @__PURE__ */ tableSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableDefaultVariants, getSlotCompoundVariant(tableCompoundVariants, slotName))])

const tableFn = memo((props = {}) => {
  return Object.fromEntries(tableSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableVariantKeys = []
const getVariantProps = (variants) => ({ ...tableDefaultVariants, ...compact(variants) })

export const table = /* @__PURE__ */ Object.assign(tableFn, {
  __recipe__: false,
  __name__: 'table',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: tableVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, tableVariantKeys)
  },
  getVariantProps
})